// Module
var code = "You should return to the bridge or waterfront you chose in the last chapter, press ‘I’m there’ when you are. ";
// Exports
module.exports = code;